export default __webpack_public_path__ + "static/Tek_Ceiling-48bfda5bf3a654f55890ad891bec1ac0.png";